module.exports = __webpack_public_path__ + "assets/img/ce0d03346deb8a045ced63d49a573ec6.png";